import IntroVideo from "../../../../content/blog/2021-05-27-ninja-coder/IntroVideo.jsx";
import React from 'react';
export default {
  IntroVideo,
  React
};